// extracted by mini-css-extract-plugin
module.exports = {"filterAssignerContainer":"PredefinedSearchEditBasic_filterAssignerContainer__1QpFo","nameInput":"PredefinedSearchEditBasic_nameInput__kGqT7"};